import type { ButtonColor } from "../button/config"
import type { CheckboxVariant } from "../form/checkbox/types"
import type { InfoCardVariant } from "./types"

import { BUTTON_COLORS } from "../button/config"
import { CHECKBOX_VARIANT } from "../form/checkbox/types"
import { INFO_CARD_VARIANT } from "./types"

export const VARIANT_CONFIG: Record<InfoCardVariant, { buttonColor: ButtonColor; checkboxColor: CheckboxVariant }> = {
  [INFO_CARD_VARIANT.info]: {
    buttonColor: BUTTON_COLORS.INFO,
    checkboxColor: CHECKBOX_VARIANT.info,
  },
  [INFO_CARD_VARIANT.success]: {
    buttonColor: BUTTON_COLORS.SUCCESS,
    checkboxColor: CHECKBOX_VARIANT.success,
  },
  [INFO_CARD_VARIANT.warning]: {
    buttonColor: BUTTON_COLORS.WARNING,
    checkboxColor: CHECKBOX_VARIANT.warning,
  },
  [INFO_CARD_VARIANT.error]: {
    buttonColor: BUTTON_COLORS.ERROR,
    checkboxColor: CHECKBOX_VARIANT.error,
  },
}
